import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, TrendingUp, Users2, ShieldCheck, ArrowRight } from "lucide-react";

export default function ForMerchants() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <div className="text-xs uppercase tracking-[0.2em] text-amber-700 font-semibold mb-2">For Merchants</div>
      <h1 className="font-display font-bold text-4xl lg:text-5xl tracking-tight text-gray-900">
        Reach AI-matched buyers ready to convert.
      </h1>
      <p className="text-gray-700 mt-4 max-w-2xl text-lg">
        LoyaltyCircle AI delivers your offers to consumers who already match your customer profile —
        and only pays you when verified purchases happen.
      </p>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { icon: TrendingUp, t: "Performance-based", b: "Pay commission only on confirmed sales — no upfront fees." },
          { icon: Sparkles, t: "AI-matched audience", b: "Ria recommends your offers to households whose profile fits." },
          { icon: Users2, t: "Loyal repeat buyers", b: "Cashback drives 3x repeat conversion vs. cold traffic." },
          { icon: ShieldCheck, t: "Compliance-first", b: "Fraud detection, brand-safe placements, transparent reporting." },
        ].map((f) => (
          <div key={f.t} className="border border-gray-200 rounded-2xl p-6 bg-white">
            <div className="w-11 h-11 rounded-xl bg-amber-50 text-amber-700 border border-amber-100 flex items-center justify-center mb-3">
              <f.icon className="w-5 h-5" />
            </div>
            <div className="font-display font-bold text-base">{f.t}</div>
            <p className="text-sm text-gray-600 mt-1.5">{f.b}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 rounded-3xl border border-gray-200 bg-white p-10 text-center">
        <h2 className="font-display font-bold text-3xl tracking-tight text-gray-900">
          Become a featured merchant
        </h2>
        <p className="text-gray-600 mt-3 max-w-xl mx-auto">
          Send us your affiliate program details and we'll match you with the right households.
        </p>
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          <a
            href="mailto:partners@rewardcircle.ai"
            data-testid="merchant-contact-btn"
            className="inline-flex items-center justify-center bg-emerald-700 hover:bg-emerald-800 text-white rounded-full px-6 py-3 text-sm font-semibold transition-colors"
          >
            Contact partnerships <ArrowRight className="w-4 h-4 ml-2" />
          </a>
          <Link to="/" className="inline-flex items-center justify-center border border-gray-300 hover:border-gray-400 text-gray-900 rounded-full px-6 py-3 text-sm font-semibold">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
